import { BaseIcon } from '../BaseIcon';
import type { BaseIconProps } from '../BaseIcon';

type NotInterestedIconProps = Omit<BaseIconProps, 'children' | 'hasLegacyStrokeStyles'>;

export const NotInterestedIcon = ({ ...props }: NotInterestedIconProps) => (
  <BaseIcon hasLegacyStrokeStyles width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        stroke="none"
        d="M8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2ZM0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        stroke="none"
        d="M2.58594 12L12.0002 2.58583L13.4144 4.00005L4.00015 13.4142L2.58594 12Z"
      />
    </>
  </BaseIcon>
);

NotInterestedIcon.displayName = 'NotInterestedIcon';
